import { useState } from "react";
import {
  Person,
  PersonData,
  SquadPositionPlayer,
} from "@/sources/kicker-amateur/types";

interface PlayerModal {
  isOpen: boolean;
  selectedPlayer: SquadPositionPlayer | PersonData | Person | undefined;
  openModal: (player: SquadPositionPlayer | PersonData | Person) => void;
  closeModal: () => void;
}

export const usePlayerModal = (initialState = false): PlayerModal => {
  const [isOpen, setIsOpen] = useState(initialState);
  const [selectedPlayer, setSelectedPlayer] = useState<
    SquadPositionPlayer | PersonData | Person | undefined
  >(undefined);

  const openModal = (player?: Person | SquadPositionPlayer | PersonData ) => {
    if (player) {
      setSelectedPlayer(player);
    }
    setIsOpen(true);
  };

  const closeModal = () => {
    setSelectedPlayer(undefined);
    setIsOpen(false);
  };

  return {
    isOpen,
    selectedPlayer,
    openModal,
    closeModal,
  };
};
